class ProductCarouselSlider extends HTMLElement {
  constructor() {
    super();
    this.slide = this.querySelector(".swiper");
  }

  connectedCallback() {
    this.initSlide();
  }

  initSlide() {
    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        cssMode: true,
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      };

      this.swiper = new Swiper(this.slide, swiperParams);
    });
  }
}

if (!customElements.get("product-carousel-slider")) {
  customElements.define("product-carousel-slider", ProductCarouselSlider);
}
